import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';

/**
 * StudentOnlyRoute — Garde qui réserve une page à l'expérience élève / visiteur.
 *
 * Comportement (mode STRICT enseignant) :
 *  - Visiteur non connecté → laisser passer (page publique).
 *  - Élève connecté         → laisser passer.
 *  - Enseignant ou Admin    → redirection vers /enseignant.
 *
 * Évite à un enseignant connecté de retomber accidentellement sur les pages
 * grand public (Home, Révision, Examen, Profil…). Il garde son expérience
 * dédiée Espace Pro.
 */
export default function StudentOnlyRoute({ children }) {
  const { user } = useApp();
  const location = useLocation();

  if (user && (user.role === 'enseignant' || user.role === 'admin')) {
    return <Navigate to="/enseignant" replace state={{ from: location.pathname }} />;
  }

  return children;
}
